const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/service-desk/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireLoggedInUser } from '@/Router';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/service-desk/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad() {
    requireLoggedInUser({
      to: '/'
    });
  },
  onEnter() {
    useAppStore.setState({
      pageType: 'unknown'
    });
  }
});